import { render, staticRenderFns } from "./mobileStatusBar.vue?vue&type=template&id=15cc6944&scoped=true"
import script from "./mobileStatusBar.vue?vue&type=script&lang=js"
export * from "./mobileStatusBar.vue?vue&type=script&lang=js"
import style0 from "./mobileStatusBar.vue?vue&type=style&index=0&id=15cc6944&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc6944",
  null
  
)

export default component.exports